import {getLocalDateTime} from './formatDate';

const MS_IN_DAY = 24 * 60 * 60 * 1000;

export const DELIVERY_RANGE_DAYS_THRESHOLD = 4;

export function getDeliveryDatesDifferenceDays(
    expectedDate?: string,
    guaranteedDate?: string
): number {
    if (!expectedDate || !guaranteedDate) {
        return 0;
    }

    const expected = getLocalDateTime(expectedDate);
    const guaranteed = getLocalDateTime(guaranteedDate);

    const expectedDayStart = new Date(
        expected.getFullYear(),
        expected.getMonth(),
        expected.getDate()
    ).getTime();
    const guaranteedDayStart = new Date(
        guaranteed.getFullYear(),
        guaranteed.getMonth(),
        guaranteed.getDate()
    ).getTime();

    return Math.round((guaranteedDayStart - expectedDayStart) / MS_IN_DAY);
}

export function shouldShowDeliveryRange(
    expectedDate?: string,
    guaranteedDate?: string,
    threshold: number = DELIVERY_RANGE_DAYS_THRESHOLD
): boolean {
    return getDeliveryDatesDifferenceDays(expectedDate, guaranteedDate) >= threshold;
}
